import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  getListTransactions,
  setTransactionDetailModal,
  setTransactionRefundConfirmModal,
  getInvoice,
  cancelOrder,
  resetCancelOrder,
} from '../../redux/actions/transactions';
import { resetFilter } from '../../../../redux/actions/newFilter';

import TransactionsPage from './Transactions.page';

const mapStateToProps = state => ({
  loading: state.allbiller.loading,
  listTransactions: state.allbiller.listTransactions,
  transactionsFilter: state.allbiller.transactionsFilter,
  transactionDetailModalShow: state.allbiller.transactionDetailModalShow,
  transactionDetailModalData: state.allbiller.transactionDetailModalData,
  transactionRefundConfirmModalShow:
    state.allbiller.transactionRefundConfirmModalShow,
  transactionRefundSelectedId: state.allbiller.transactionRefundSelectedId,
  filterValue: state.newFilter.filterValue,
  cancelOrderResponse: state.allbiller.cancelOrderResponse,
  cancelOrderError: state.allbiller.cancelOrderError,
  cancelOrderLoading: state.allbiller.cancelOrderLoading,
  formControlShow: state.newFilter.formControlShow,
});

const mapDispatchToProps = {
  getListTransactions,
  setTransactionDetailModal,
  setTransactionRefundConfirmModal,
  getInvoice,
  resetFilter,
  cancelOrder,
  resetCancelOrder,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TransactionsPage));
